import { useState, useEffect } from 'react';
function safeRandomUUID() {
  // In some environments (like Jest/jsdom), `crypto` may be undefined.
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  // RFC4122-ish fallback (good enough for anonymous local IDs)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function useUser() {
  const [userId, setUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function initializeUser() {
      let storedUserId = localStorage.getItem('top100_user_id');
      
      if (!storedUserId) {
        storedUserId = safeRandomUUID();
        localStorage.setItem('top100_user_id', storedUserId);
      }
      
      setUserId(storedUserId);
      setLoading(false);
    }

    initializeUser();
  }, []);

  return { userId, loading };
}

